import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ErrorService} from '@app/services';
import {TextTranslated} from '../../text-translated';

@Component({
  selector: 'hpf-text-translated-create',
  templateUrl: './text-translated-create.component.html'
})
export class TextTranslatedCreateComponent implements OnInit {
  /** The text translated */
  textTranslated = new TextTranslated();

  /** Constructor */
  constructor(private router: Router,
              private errorService: ErrorService) {
  }
  /** Init */
  ngOnInit() {
  }
  /** Called when the text translated is created */
  onCreate(textTranslated: TextTranslated): void {
    this.router.navigateByUrl(`/text-translated/${textTranslated.getId()}`)
      .catch((error) => this.errorService.handle(error));
  }

}
